import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const SESSION_KEY = "aip_session_id";

const getSessionId = () => {
  let sid = sessionStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid =
      (window.crypto && window.crypto.randomUUID && window.crypto.randomUUID()) ||
      `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
};

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const send = () => {
      const consent = localStorage.getItem("cookie_consent");
      if (consent !== "accepted") return;

      const payload = {
        path: location.pathname + (location.search || ""),
        session_id: getSessionId(),
        referrer: document.referrer || "",
        user_agent: navigator.userAgent || "",
        screen_width: window.innerWidth || 0,
      };

      axios.post(`${BACKEND_URL}/api/track`, payload).catch(() => {
        /* silent fail — never block UX for analytics */
      });
    };

    send();
    window.addEventListener("cookie_consent_changed", send);
    return () => window.removeEventListener("cookie_consent_changed", send);
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsTracker;
